<template>
    <div class="card m-1">
        <div class="card-body">
            <div class="card-text mb-2" v-if="header">
                <span class="fw-bold">{{ header }}</span>
            </div>
            <slot name="body"></slot>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Card',
    props: {
        header: String,
    },
}
</script>

<style scoped></style>